import { useTranslation } from 'next-i18next';
import React from 'react';

import {
  ProductPurchaseDetails,
  ProductPurchasingController,
} from '../../../../types/Purchasing';
import { renderArtistsNamesFromPageContent } from '../../../../utils/artists';
import { Image } from '../../../Image';
import { ProductPrice } from '../../../ProductPrice/ProductPrice';

interface WorkPreviewProps<T extends ProductPurchaseDetails> {
  artists: ArtistPageContent[] | undefined;
  product: ProductType;
  purchasing: ProductPurchasingController<T>;
}

const WorkPreview: React.FC<WorkPreviewProps<ProductPurchaseDetails>> = (
  props,
) => {
  const { artists, product, purchasing } = props;
  const { t } = useTranslation('product');

  if (!purchasing.product) return null;

  const supportsFraming = Boolean(purchasing.frameOptions?.length);

  const price = (() => {
    if (!purchasing.frame) return purchasing.product.price;

    return (
      purchasing.frame.variant.consolidatedVariants[0].price +
      purchasing.product.price
    );
  })();

  return (
    <div className="flex items-center justify-center space-x-3">
      <div className="h-18 w-18 shrink-0 overflow-hidden rounded-sm">
        <Image
          alt={product.title}
          src={product.thumbnail.filename}
          width={96}
        />
      </div>
      <div className="flex flex-1 flex-col justify-center">
        <p className="font-bold">
          {renderArtistsNamesFromPageContent(artists)}
        </p>
        <p>{product.title}</p>
        {supportsFraming && (
          <p className="text-neutral-4">
            {purchasing.frame
              ? t('drawers.fees.workFramed')
              : t('drawers.fees.workUnframed')}
          </p>
        )}
      </div>
      <ProductPrice className="shrink-0" price={price} />
    </div>
  );
};

export default WorkPreview;
